var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-page",
    { staticClass: "w-container root" },
    [
      _vm._l(_vm.state.sale.Rows, function (row, i) {
        return _c(
          "w-row",
          { key: i },
          [
            _c(
              "w-col",
              { attrs: { xs: "12" } },
              [
                _c(
                  "w-card",
                  [
                    _c(
                      "w-card-title",
                      [
                        _vm._v(
                          " " +
                            _vm._s(row.Amount) +
                            ": " +
                            _vm._s(row.ProductSku) +
                            " "
                        ),
                        _c("w-spacer"),
                        _c(
                          "w-button",
                          {
                            attrs: { flat: "", sm: "" },
                            on: {
                              click: function ($event) {
                                return _vm.editRow(row)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "pen" } })],
                          1
                        ),
                        _c(
                          "w-button",
                          {
                            attrs: { flat: "", sm: "" },
                            on: {
                              click: function ($event) {
                                return _vm.removeRow(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-card-content",
                      [
                        _c(
                          "w-row",
                          [
                            _c("w-col", { attrs: { xs: "12" } }, [
                              _c("span", {
                                directives: [
                                  {
                                    name: "safe-html",
                                    rawName: "v-safe-html",
                                    value: _vm.getDescription(
                                      row.ProductDescription
                                    ),
                                    expression:
                                      "getDescription(row.ProductDescription)",
                                  },
                                ],
                              }),
                              _c("span", { staticClass: "label" }, [
                                _vm._v(
                                  " € " +
                                    _vm._s(
                                      _vm._f("humanFloat")(row.UnitPrice, 2)
                                    ) +
                                    "/" +
                                    _vm._s(_vm.$ct("qty")) +
                                    " "
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "w-row",
                          [
                            _c("w-col", { attrs: { xs: "5" } }, [
                              _c("div", [
                                row.Discount != 0
                                  ? _c("span", { staticClass: "discount" }, [
                                      _vm._v(_vm._s(row.Discount)),
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  " € " +
                                    _vm._s(
                                      _vm._f("humanFloat")(row.NettoPrice, 2)
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("div", { staticClass: "label" }, [
                                _vm._v(" " + _vm._s(_vm.$ct("netto")) + " "),
                              ]),
                            ]),
                            _c(
                              "w-col",
                              {
                                staticClass: "right-align",
                                attrs: { xs: "2" },
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("humanFloat")(row.Vat, 1)) +
                                      "% "
                                  ),
                                ]),
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(" " + _vm._s(_vm.$ct("vat")) + " "),
                                ]),
                              ]
                            ),
                            _c(
                              "w-col",
                              {
                                staticClass: "right-align",
                                attrs: { xs: "5" },
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    " € " +
                                      _vm._s(
                                        _vm._f("humanFloat")(row.BrutoPrice, 2)
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(" " + _vm._s(_vm.$ct("bruto")) + " "),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm.state.sale.Rows.length == 0
        ? _c(
            "w-row",
            { staticClass: "no-rows" },
            [
              _c("w-col", { attrs: { xs: "12" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("no-rows")) + " "),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c("w-spacer"),
      _c(
        "w-button",
        {
          staticClass: "fab shadow",
          attrs: { round: "", xl: "", disabled: _vm.addRowDisabled },
          on: {
            click: function ($event) {
              return _vm.addRow()
            },
          },
        },
        [_c("w-fa", { attrs: { icon: "plus" } })],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.editRowOpened } },
        [_c("app-sale-edit-mobile-edit-row", { attrs: { state: _vm.state } })],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }